// extracted by mini-css-extract-plugin
module.exports =  {"alert":"alert--yu1TS","success":"success--K0Wu2","primary":"primary--lBgmw","danger":"danger--h5IC9","error":"error--ZSPRW","secondary":"secondary--Qiwv1"};